import { Typography } from '@mui/material';
import React from 'react';
import Dashboard from 'types/entities/Dashboard';

const OrderTypeCell = React.memo((row: Dashboard) => {
  if (!row?.order_type) return null;
  let displayValue = '';
  if (row.order_type === 1) {
    displayValue = 'Catalog';
  } else if (row.order_type === 2) {
    displayValue = 'T&M';
  } else {
    displayValue = '';
  }
  return (
    <Typography variant="body2" noWrap>
      {displayValue}
    </Typography>
  );
});
export default OrderTypeCell;
